import gql from 'graphql-tag';

const updateUserMutation = gql`
  mutation adminUpdateUser($input: AdminModifyUserInput!) {
    adminUpdateUser(input: $input) {
      success
      errors
    }
  }
`;

export default updateUserMutation;
